import React, { useState, useEffect } from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import contentService from "../services/contentService";

export default function Home() {
  const [homeContent, setHomeContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomeContent = async () => {
      try {
        const response = await contentService.getHomeContent();
        if (response.success) {
          setHomeContent(response.data);
        } else {
          setError("Failed to load content");
        }
      } catch (err) {
        setError("Failed to load content");
        console.error("Error fetching home content:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHomeContent();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  return (
    <>
      <Hero content={homeContent?.hero} />
      <Services content={homeContent?.features} />
      <About stats={homeContent?.stats} />
      <Portfolio />
    </>
  );
}


